import { useContext } from "react";
import CartContext from "../../context/cart";
import UserContext from "../../context/user";
import CartSummary from "./cart-summary";

const PickUpSede = () => {
  const { userProfile } = useContext(UserContext);
  const { labels, cartRequest } = useContext(CartContext);

  return (
    <>
      <div
        className="carrello-content__text"
        dangerouslySetInnerHTML={{
          __html: (
            labels?.WELFARE_PICKUP_SEDE ||
            "<p><strong>Ciao [USER]</strong><br/>Il carrello ti verrà consegnato direttamente presso la sede di lavoro. Il Welfare EssilorLuxottica ti manderà una mail con ulteriori dettagli quando verrà programmata la distribuzione.</p>"
          ).replace(
            "[USER]",
            `<span translate="no">${userProfile?.firstName} ${userProfile?.lastName}</span>`
          ),
        }}
      />

      {cartRequest?.defaultCartAssigned && (
        <>
          <CartSummary variant="default" readOnly={true} />
          <div
            className="carrello-content__text"
            dangerouslySetInnerHTML={{
              __html:
                labels?.WELFARE_CONTACT_US_INFO ||
                "Per qualsisasi dubbio o informazione scrivi a: <a href='mailto:welfare@essilorluxottica.com'>welfare@essilorluxottica.com</a>",
            }}
          />
        </>
      )}
    </>
  );
};

export default PickUpSede;
